const SITE_URL = "https://plan2benefit.com";
const SITE_NAME = "P2B";
// Former brand name, kept as alternateName so Google links the two.
const SITE_ALT_NAME = "Plan2Benefit";
// Link-preview image (WhatsApp, Facebook, X, LinkedIn…) — 1200×630.
const DEFAULT_IMAGE = `${SITE_URL}/p2b-og.jpg`;
const DEFAULT_IMAGE_ALT = "P2B – First Month EMI FREE on all types of loans";

// Only the live production domain should ever be indexable. Every other host
// (staging, Firebase preview, localhost) is forced to noindex,nofollow.
const PRODUCTION_HOSTS = ["plan2benefit.com", "www.plan2benefit.com"];

function isProductionHost() {
  if (typeof window === "undefined") return true; // prerender runs for prod
  return PRODUCTION_HOSTS.includes(window.location.hostname);
}

const siteSchemas = [
  {
    type: "script",
    props: { type: "application/ld+json" },
    children: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      name: SITE_NAME,
      alternateName: SITE_ALT_NAME,
      legalName: "Pardna Technologies Private Limited",
      url: SITE_URL,
      logo: `${SITE_URL}/p2b-icon-512.png`,
      contactPoint: {
        "@type": "ContactPoint",
        email: "admin@plan2benefit.com",
        contactType: "customer support",
      },
    }),
  },
  {
    type: "script",
    props: { type: "application/ld+json" },
    children: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: SITE_NAME,
      alternateName: SITE_ALT_NAME,
      url: SITE_URL,
      inLanguage: "en-IN",
      publisher: {
        "@type": "Organization",
        name: "Pardna Technologies Private Limited",
      },
    }),
  },
  {
    type: "script",
    props: { type: "application/ld+json" },
    children: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "Plan2Benefit App",
      applicationCategory: "FinanceApplication",
      operatingSystem: "Android, iOS",
      description:
        "Get the first month's EMI free on car, home, personal, gold and education loans — compare 40+ banks and lenders and get the lowest interest rates.",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "INR",
      },
    }),
  },
];

/* ── Home FAQ rich-result schema ──────────────────────────────
   Keep answers in sync with LOAN_FAQS in
   components/Plan2BenefitCarVersion/CarLoanApply.jsx (the homepage FAQ). */
const HOME_FAQ = [
  {
    q: "How does the first month EMI cashback work?",
    a: "You pay your first EMI to the lender as usual. Before your final loan approval, P2B will clearly show you the applicable cashback percentage and cashback amount, so you know your benefit before proceeding. For example: First EMI ₹20,000, P2B Cashback 80%, Cashback ₹16,000. Or: First EMI ₹20,000, P2B Cashback 100%, Cashback ₹20,000. Once your eligible loan is successfully disbursed through the bank, P2B provides the applicable cashback to your bank account.",
  },
  {
    q: "Secret trick behind the first month EMI cashback?",
    a: "We don’t hide the 1st EMI cashback in your processing charges — zero processing fee bumps. Get the exact same interest rates offline with banks — no markups. No insurance traps. No tenure extension. No double EMI next month: your second month EMI is just a normal, single EMI. No CIBIL impact.",
  },
  {
    q: "Which loans are eligible for the First Month EMI FREE* benefit?",
    a: "All types of loans are eligible for the First Month EMI FREE* benefit — Car loan, Home loan, Commercial Vehicle loan, Personal loan, Gold loan, Business loan and Travel loan.",
  },
  {
    q: "How does P2B help me find a loan?",
    a: "Tell us what loan you need and share your basic details. P2B helps you explore available options from 40+ banks and lenders, including applicable interest rates, loan amounts and terms.",
  },
  {
    q: "Does P2B guarantee the lowest interest rate?",
    a: "Interest rates depend on your profile, loan type, credit history, income, lender policies and other factors. P2B helps you discover and compare available options; the final rate is determined by the selected lender.",
  },
  {
    q: "What happens after my first month?",
    a: "From the second month onwards, pay your eligible EMI as usual. You can earn P2B Coins through eligible activities and use them to claim applicable cashback and rewards.",
  },
  {
    q: "Will I get the same interest rate through P2B as I would by applying directly to the bank?",
    a: "Yes. P2B helps you explore loan options from banks and lenders at their applicable interest rates. You get the same lender-determined rate you would be offered through the bank, while also getting the First Month EMI FREE* benefit and the convenience of completing the process from the comfort of your home.",
  },
  {
    q: "Is P2B a bank or lender?",
    a: "P2B is a technology platform that helps customers discover and explore available loan options from banks and lenders. The selected lender is responsible for approving and disbursing the loan.",
  },
];

const homeFaqSchema = {
  type: "script",
  props: { type: "application/ld+json" },
  children: JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: HOME_FAQ.map(({ q, a }) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: { "@type": "Answer", text: a },
    })),
  }),
};

const PAGE_META = {
  "/": {
    title: "P2B – First Month EMI Free",
    description:
      "First month EMI free on all types of loans with 40+ bank options and lowest interest rates.",
    keywords:
      "first emi, emi free, car loan, vehicle loan, home loan, personal loan, gold loan, education loan",
    canonical: SITE_URL,
    robots: "index,follow,max-image-preview:large",
    ogTitle: "P2B – First Month EMI Free",
    ogDescription:
      "First month EMI free on all types of loans with 40+ bank options and lowest interest rates.",
    ogUrl: SITE_URL,
    twitterTitle: "P2B – First Month EMI Free",
    twitterDescription:
      "First month EMI free on all types of loans with 40+ bank options and lowest interest rates.",
  },
  "/aboutUs": {
    title: "About P2B | First Month EMI Free on Loans",
    description:
      "Learn how P2B gets you the first month's EMI free on car, home, personal, gold and education loans, with 40+ bank options and the lowest interest rates.",
    keywords:
      "About P2B, first EMI, EMI free, car loan, home loan, personal loan, gold loan, education loan, lowest interest rates, 40+ banks",
    canonical: `${SITE_URL}/aboutUs/`,
    robots: "index,follow",
    ogTitle: "About P2B | First Month EMI Free on Loans",
    ogDescription:
      "Learn how P2B gets you the first month's EMI free on car, home, personal, gold and education loans, with 40+ bank options and the lowest interest rates.",
    ogUrl: `${SITE_URL}/aboutUs/`,
    twitterTitle: "About P2B | First Month EMI Free on Loans",
    twitterDescription:
      "Learn how P2B gets you the first month's EMI free on car, home, personal, gold and education loans, with 40+ bank options and the lowest interest rates.",
  },
  "/meetTheTeam": {
    title: "Meet the Team | P2B",
    description:
      "Meet the founders and team building P2B's First Month EMI Free loan experience and product design.",
    keywords:
      "P2B team, founders, engineering team, product team, loan app team, company team, meet the team, Behind P2B, P2B App",
    canonical: `${SITE_URL}/meetTheTeam/`,
    robots: "index,follow",
    ogTitle: "Meet the Team | P2B",
    ogDescription:
      "Meet the founders and team building P2B's First Month EMI Free loan experience and product design.",
    ogUrl: `${SITE_URL}/meetTheTeam/`,
    twitterTitle: "Meet the Team | P2B",
    twitterDescription:
      "Meet the founders and team building P2B's First Month EMI Free loan experience and product design.",
  },
  "/contact": {
    title: "Contact P2B | Support and Enquiries",
    description:
      "Get in touch with P2B for support, product enquiries, partnerships, or business conversations, P2B Support, P2B Contact",
    keywords:
      "Contact P2B, support, enquiries, partnerships, business contact, customer support, email P2B",
    canonical: `${SITE_URL}/contact/`,
    robots: "index,follow",
    ogTitle: "Contact P2B | Support and Enquiries",
    ogDescription:
      "Get in touch with P2B for support, product enquiries, partnerships, or business conversations.",
    ogUrl: `${SITE_URL}/contact/`,
    twitterTitle: "Contact P2B | Support and Enquiries",
    twitterDescription:
      "Get in touch with P2B for support, product enquiries, partnerships, or business conversations.",
  },
  "/careers": {
    title: "Careers at P2B | Work With Us",
    description:
      "Explore career opportunities at P2B and join a team building First Month EMI Free loan products.",
    keywords:
      "P2B careers, jobs at P2B, fintech jobs, product jobs, engineering jobs, startup careers, P2B Team, Work At P2B",
    canonical: `${SITE_URL}/careers/`,
    robots: "index,follow",
    ogTitle: "Careers at P2B | Work With Us",
    ogDescription:
      "Explore career opportunities at P2B and join a team building First Month EMI Free loan products.",
    ogUrl: `${SITE_URL}/careers/`,
    twitterTitle: "Careers at P2B | Work With Us",
    twitterDescription:
      "Explore career opportunities at P2B and join a team building First Month EMI Free loan products.",
  },
  "/privacyPolicy": {
    title: "Privacy Policy | P2B",
    description:
      "Read how P2B collects, uses, and protects user data within the P2B app and related loan services.",
    keywords:
      "Privacy Policy, P2B privacy, data protection, user data, loan data privacy, personal information",
    canonical: `${SITE_URL}/privacyPolicy/`,
    robots: "index,follow",
    ogTitle: "Privacy Policy | P2B",
    ogDescription:
      "Read how P2B collects, uses, and protects user data within the P2B app and related loan services.",
    ogUrl: `${SITE_URL}/privacyPolicy/`,
    twitterTitle: "Privacy Policy | P2B",
    twitterDescription:
      "Read how P2B collects, uses, and protects user data within the P2B app and related loan services.",
  },
  "/termsAndConditions": {
    title: "Terms & Conditions | P2B",
    description:
      "Review the terms that govern use of P2B, including loan application rules, user rights, and platform responsibilities.",
    keywords:
      "Terms and Conditions, P2B terms, loan application rules, user rights, platform responsibilities",
    canonical: `${SITE_URL}/termsAndConditions/`,
    robots: "index,follow",
    ogTitle: "Terms & Conditions | P2B",
    ogDescription:
      "Review the terms that govern use of P2B, including loan application rules, user rights, and platform responsibilities.",
    ogUrl: `${SITE_URL}/termsAndConditions/`,
    twitterTitle: "Terms & Conditions | P2B",
    twitterDescription:
      "Review the terms that govern use of P2B, including loan application rules, user rights, and platform responsibilities.",
  },
  "/investor": {
    title: "Investor Deck | P2B",
    description:
      "Private investor deck for P2B — the First Month EMI Free lending platform for India.",
    keywords: "",
    canonical: null,
    robots: "noindex,nofollow",
    ogTitle: "Investor Deck | P2B",
    ogDescription:
      "Private investor deck for P2B — the First Month EMI Free lending platform for India.",
    ogUrl: `${SITE_URL}/investor`,
    twitterTitle: "Investor Deck | P2B",
    twitterDescription:
      "Private investor deck for P2B — the First Month EMI Free lending platform for India.",
  },
  "/investment": {
    title: "Investment Deck | P2B",
    description:
      "Full investment deck for P2B — the First Month EMI Free lending platform for India.",
    keywords: "",
    canonical: null,
    robots: "noindex,nofollow",
    ogTitle: "Investment Deck | P2B",
    ogDescription:
      "Full investment deck for P2B — the First Month EMI Free lending platform for India.",
    ogUrl: `${SITE_URL}/investment`,
    twitterTitle: "Investment Deck | P2B",
    twitterDescription:
      "Full investment deck for P2B — the First Month EMI Free lending platform for India.",
  },
  "/refundAndCancellation": {
    title: "Refund and Cancellation Policy | P2B",
    description:
      "Understand how refunds, cancellation, and missed EMI payments work inside P2B.",
    keywords:
      "Refund and cancellation, P2B refund policy, cancellation policy, missed EMI payments",
    canonical: `${SITE_URL}/refundAndCancellation/`,
    robots: "index,follow",
    ogTitle: "Refund and Cancellation Policy | P2B",
    ogDescription:
      "Understand how refunds, cancellation, and missed EMI payments work inside P2B.",
    ogUrl: `${SITE_URL}/refundAndCancellation/`,
    twitterTitle: "Refund and Cancellation Policy | P2B",
    twitterDescription:
      "Understand how refunds, cancellation, and missed EMI payments work inside P2B.",
  },
};

function stripTrailingSlash(pathname) {
  if (!pathname) return "/";
  const clean = pathname.replace(/\/+$/, "");
  return clean || "/";
}

function getBaseMeta(pathname) {
  const cleanPath = stripTrailingSlash(pathname);
  if (cleanPath.startsWith("/me/")) {
    return {
      title: "P2B | Shared Earnings",
      description:
        "View a shared earnings page inside P2B. This page is private and not intended for search indexing.",
      keywords: "",
      canonical: null,
      robots: "noindex,nofollow",
      ogTitle: "P2B | Shared Earnings",
      ogDescription:
        "View a shared earnings page inside P2B. This page is private and not intended for search indexing.",
      ogUrl: `${SITE_URL}${cleanPath}`,
      twitterTitle: "P2B | Shared Earnings",
      twitterDescription:
        "View a shared earnings page inside P2B. This page is private and not intended for search indexing.",
    };
  }

  if (cleanPath.startsWith("/dl")) {
    return {
      title: "P2B | App Download",
      description:
        "Open the P2B app download flow. This page is not meant for search indexing.",
      keywords: "",
      canonical: null,
      robots: "noindex,nofollow",
      ogTitle: "P2B | App Download",
      ogDescription:
        "Open the P2B app download flow. This page is not meant for search indexing.",
      ogUrl: `${SITE_URL}${cleanPath}`,
      twitterTitle: "P2B | App Download",
      twitterDescription:
        "Open the P2B app download flow. This page is not meant for search indexing.",
    };
  }

  return PAGE_META[cleanPath] || {
    title: "Page Not Found | P2B",
    description:
      "The page you were looking for does not exist on P2B.",
    keywords: "",
    canonical: null,
    robots: "noindex,follow",
    ogTitle: "Page Not Found | P2B",
    ogDescription:
      "The page you were looking for does not exist on P2B.",
    ogUrl: `${SITE_URL}${cleanPath}`,
    twitterTitle: "Page Not Found | P2B",
    twitterDescription:
      "The page you were looking for does not exist on P2B."
  };
}

function buildElements(meta, extraSchemas = []) {
  return [
    {
      type: "meta",
      props: { name: "description", content: meta.description },
    },
    ...(meta.keywords
      ? [
          {
            type: "meta",
            props: { name: "keywords", content: meta.keywords },
          },
        ]
      : []),
    {
      type: "meta",
      props: { name: "robots", content: meta.robots },
    },
    {
      type: "meta",
      props: { property: "og:title", content: meta.ogTitle },
    },
    {
      type: "meta",
      props: { property: "og:description", content: meta.ogDescription },
    },
    {
      type: "meta",
      props: { property: "og:url", content: meta.ogUrl },
    },
    {
      type: "meta",
      props: { property: "og:type", content: "website" },
    },
    {
      type: "meta",
      props: { property: "og:image", content: DEFAULT_IMAGE },
    },
    {
      type: "meta",
      props: { property: "og:image:width", content: "1200" },
    },
    {
      type: "meta",
      props: { property: "og:image:height", content: "630" },
    },
    {
      type: "meta",
      props: { property: "og:image:alt", content: DEFAULT_IMAGE_ALT },
    },
    {
      type: "meta",
      props: { property: "og:site_name", content: SITE_NAME },
    },
    {
      type: "meta",
      props: { name: "twitter:card", content: "summary_large_image" },
    },
    {
      type: "meta",
      props: { name: "twitter:title", content: meta.twitterTitle },
    },
    {
      type: "meta",
      props: { name: "twitter:description", content: meta.twitterDescription },
    },
    {
      type: "meta",
      props: { name: "twitter:image", content: DEFAULT_IMAGE },
    },
    ...siteSchemas,
    ...extraSchemas,
  ].filter(Boolean).concat(
    meta.canonical
      ? [
          {
            type: "link",
            props: { rel: "canonical", href: meta.canonical },
          },
        ]
      : []
  );
}

export function getSeoForPath(pathname) {
  const meta = getBaseMeta(pathname);
  const isHome = stripTrailingSlash(pathname) === "/";
  const extraSchemas = isHome ? [homeFaqSchema] : [];
  return {
    lang: "en",
    title: meta.title,
    elements: new Set(buildElements(meta, extraSchemas)),
  };
}

export function applySeoToDocument(pathname) {
  if (typeof document === "undefined") return;

  const meta = getBaseMeta(pathname);
  document.documentElement.lang = "en";
  document.title = meta.title;

  const upsert = (selector, attrs, tagName = "meta") => {
    let el = document.head.querySelector(selector);
    if (!el) {
      el = document.createElement(tagName);
      Object.entries(attrs).forEach(([key, value]) => {
        el.setAttribute(key, value);
      });
      document.head.appendChild(el);
      return;
    }
    Object.entries(attrs).forEach(([key, value]) => {
      el.setAttribute(key, value);
    });
  };

  const remove = (selector) => {
    const el = document.head.querySelector(selector);
    if (el) {
      el.remove();
    }
  };

  upsert('meta[name="description"]', {
    name: "description",
    content: meta.description,
  });
  if (meta.keywords) {
    upsert('meta[name="keywords"]', { name: "keywords", content: meta.keywords });
  } else {
    remove('meta[name="keywords"]');
  }
  upsert('meta[name="robots"]', {
    name: "robots",
    content: isProductionHost() ? meta.robots : "noindex, nofollow",
  });
  if (meta.canonical) {
    upsert('link[rel="canonical"]', { rel: "canonical", href: meta.canonical }, "link");
  } else {
    remove('link[rel="canonical"]');
  }
  upsert('meta[property="og:title"]', {
    property: "og:title",
    content: meta.ogTitle,
  });
  upsert('meta[property="og:description"]', {
    property: "og:description",
    content: meta.ogDescription,
  });
  upsert('meta[property="og:url"]', { property: "og:url", content: meta.ogUrl });
  upsert('meta[property="og:type"]', { property: "og:type", content: "website" });
  upsert('meta[property="og:image"]', {
    property: "og:image",
    content: DEFAULT_IMAGE,
  });
  upsert('meta[property="og:image:width"]', { property: "og:image:width", content: "1200" });
  upsert('meta[property="og:image:height"]', { property: "og:image:height", content: "630" });
  upsert('meta[property="og:image:alt"]', { property: "og:image:alt", content: DEFAULT_IMAGE_ALT });
  upsert('meta[property="og:site_name"]', {
    property: "og:site_name",
    content: SITE_NAME,
  });
  upsert('meta[name="twitter:card"]', {
    name: "twitter:card",
    content: "summary_large_image",
  });
  upsert('meta[name="twitter:title"]', {
    name: "twitter:title",
    content: meta.twitterTitle,
  });
  upsert('meta[name="twitter:description"]', {
    name: "twitter:description",
    content: meta.twitterDescription,
  });
  upsert('meta[name="twitter:image"]', {
    name: "twitter:image",
    content: DEFAULT_IMAGE,
  });
}
